import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Link,
  Box,
} from '@mui/material';
import { OpenInNew as OpenInNewIcon } from '@mui/icons-material';
import PriorityMatrix from './PriorityMatrix';
import TaskManagement from './TaskManagement';

const NotionLink: React.FC = () => {
  const notionUrl = 'https://www.notion.so/Todo-Today-22f296896e13803bb9eee1e0b72eef54?pvs=12';

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Pasos
        </Typography>
        
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Link
            href={notionUrl}
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              fontSize: '1.1rem',
              fontWeight: 500,
              color: 'primary.main',
              '&:hover': {
                color: 'primary.light',
              },
            }}
          >
            Notion
            <OpenInNewIcon fontSize="small" />
          </Link>
        </Box>

        <TaskManagement />

        <PriorityMatrix />
      </CardContent>
    </Card>
  );
};

export default NotionLink;
